/* @flow */
import Cookies from 'lib/Cookies';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

export function requireCookiesWithRedirect(redirectUri: string, forwardQueryParams?: boolean) {
  return function(
    nextState: RouterState,
    replaceWith: (location: LocationDescriptor) => void,
    callback: Function
  ) {
    const redirectToCookiesDisabled = function() {
      const newUri = forwardQueryParams ? redirectUri + window.location.search : redirectUri;
      replaceWith(newUri);
      callback();
    };

    if (Cookies.isEnabled()) {
      callback();
    } else {
      redirectToCookiesDisabled();
    }
  };
}

// for backwards compatabiltiy with existing codebase.
const requireCookies = requireCookiesWithRedirect('/f/cookies_disabled');
export default requireCookies;
